import React from "react";
import { ButtonResolver } from "../../Element";

export const HeaderButtonSettings = () => (
  <ButtonResolver resolve="settings" svg="cog" />
);
